import {
  setCheckButtons,
  setTableButtons,
  setFormButtons,
  getStepFormBottomButtons
} from '@/utils/getbuttons.js'
import { daysFormat } from '@/filters'
import person from '@/utils/pageParams/person.js'
import { withSelectedOption, withSelectedOptions } from '@/utils/handleData.js'
import {
  isLaborCompanyOrg,
  getLaborParentBidUid,
  getLaborParentBidName,
  getLaborCompanyName
} from '@/utils/bidLevelActions.js'
import esign from '@/utils/pageParams/esign.js'
const personUser = {
  title: '新增个人档案',
  addFun: 'user/addPersonUser',
  detailPage: [
    {
      buttonName: '弹窗提交',
      type: 'cardForm',
      name: 'person',
      step: 'personInfo',
      theme: 'builder',
      label: '完善个人档案',
      pageStatus: 'add'
    }
  ],
  formParams: {
    telphoneNum: '',
    personName: ''
  },
  formRules: {
    telphoneNum: [
      {
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      },
      {
        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
        message: '手机号码输入不合法',
        trigger: 'blur'
      }
    ],
    personName: [
      {
        validator: (params) => {
          return params.validate.validatePersonName
        },
        trigger: 'blur'
      }
    ]
  },
  formData: [
    {
      key: 'telphoneNum',
      label: '手机号码',
      type: 'input',
      placeholder: '请输入手机号码按回车键验证用户是否已存在',
      span: 18
    },
    {
      key: 'personName',
      label: '人员姓名',
      type: 'input',
      placeholder: '系统自动查询用户关联人员',
      disabled: true,
      span: 18
    },
    {
      type: 'tag',
      isShow: (params) => {
        return params.formError.tag
      },
      tag: (params) => {
        return params.formError.tag ? params.formError.tag : null
      },
      span: 18
    }
  ]
}
const builder = {
  pageTabs: [
    {
      label: '劳务人员',
      theme: 'builder',
      step: 'laborPersonList',
      stepLabel: '劳务人员列表',
      checkFun: 'builder/getLaborPersonList'
    },
    {
      label: '管理人员',
      theme: 'builder',
      step: 'managePersonList',
      stepLabel: '管理人员列表',
      checkFun: 'builder/getManagePersonList'
    }
  ],
  laborPerson: {
    name: 'laborPerson',
    theme: '劳务人员',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'dialogForm',
      'perForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'builder/getLaborPersonList',
    deleteFun: 'builder/deleteLaborPerson',
    deleteConfirm: (params) => {
      if (params.userName === 'dpnadmin') {
        return '将删除该劳务人员在所在项目的全部业务数据，且不可恢复。是否继续？'
      }
      return '此操作将永久删除该条数据, 是否继续?'
    },
    getDetailFun: 'builder/getLaborPersonInfo',
    addFun: 'builder/addLaborPerson',
    editFun: 'builder/editLaborPerson',
    exitFun: 'builder/exitLaborPerson',
    exitArray: true,
    selectColumn: true,
    detailPage: [
      {
        buttonNames: ['进场', '批量退场'],
        type: 'stepForm',
        name: 'laborPerson',
        step: 'laborPersonInfo',
        theme: 'builder',
        label: () => {
          return (params) => {
            if (params.code === 'add') {
              return '劳务人员进场登记'
            } else if (params.code === 'batch') {
              return '劳务人员批量退场'
            }
          }
        }
      },
      {
        buttonNames: ['编辑', '退场', '查看'],
        type: 'stepForm',
        name: 'laborPerson',
        checkType: 'checkByUid',
        checkFun: 'builder/getLaborPersonInfo',
        step: 'laborPersonInfo',
        theme: 'builder',
        label: () => {
          return (params) => {
            if (params.code === 'edit') {
              return '编辑劳务人员信息'
            } else if (params.code === 'check') {
              return '查看劳务人员信息'
            } else if (params.code === 'exit') {
              return '劳务人员退场登记'
            }
          }
        }
      },
      {
        buttonName: '查看个人档案',
        type: 'cardForm',
        name: 'person',
        label: '查看个人档案',
        theme: 'builder',
        step: 'personInfo',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.formValues ? params.formValues.personUid : ''
        },
        checkFun: 'person/getPersonInfo',
        pageStatus: 'complete'
      },
      {
        buttonName: '查看或完善个人档案',
        type: 'cardForm',
        name: 'person',
        label: '查看或完善个人档案',
        theme: 'builder',
        step: 'personInfo',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.formValues ? params.formValues.personUid : ''
        },
        checkFun: 'person/getPersonInfo',
        pageStatus: 'complete'
      },
      {
        buttonName: '完善档案工种',
        type: 'dialogForm',
        name: 'personBusiness',
        pageStatus: 'add',
        uidKey: 'personUid'
      },
      {
        buttonName: '添加新工种',
        type: 'dialogForm',
        name: 'addPersonBusiness',
        pageStatus: 'add',
        uidKey: 'personUid'
      },
      {
        buttonName: '去添加人员',
        type: 'cardForm',
        name: 'person',
        theme: 'builder',
        step: 'personInfo',
        label: '新增人员档案',
        pageStatus: 'adminAdd'
      },
      {
        buttonName: '添加新签名',
        type: 'dialogForm',
        name: 'signature',
        pageStatus: 'add',
        uidKey: 'personUid'
      },
      {
        buttonName: '添加银行卡',
        type: 'dialogForm',
        name: 'bankCard',
        pageStatus: 'add',
        uidKey: 'personUid'
      },
      {
        buttonName: '退场承诺书',
        type: 'preview'
      }
    ],
    headButtons: setCheckButtons(['进场', '批量退场']),
    queryParams: {
      organUid: (params) => {
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidUid(params) || params.orgValue
        }
        return params.orgValue
      },
      vProjectUid: (params) => {
        if (params.orgType === 'simPro') return params.orgValue
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidUid(params)
        }
        return ''
      },
      laborTeamUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      teamUid: '',
      businessUid: '',
      isExit: '',
      ageUid: '',
      query: ''
    },
    selectData: (params) => {
      const fields = []
      if (!isLaborCompanyOrg(params.orgType)) {
        fields.push(
          {
            key: 'vProjectUid',
            label: '所属项目标段',
            type: 'select',
            options: (item) => {
              return item.state.bidSection.subBidSection
            },
            checkByValue: true
          },
          {
            key: 'laborTeamUid',
            label: '所属劳务公司',
            type: 'select',
            placeholder: '请先选择项目标段后再选择',
            options: (item) => {
              return item.state.bidSection.laborCompanyNames
            },
            filterable: true,
            checkByValue: true
          },
          {
            key: 'teamUid',
            label: '所属班组',
            type: 'select',
            placeholder: '请先选择所属劳务公司',
            options: (params) => {
              return params.state.contractor.teamNames
            },
            filterable: true,
            checkByValue: true
          }
        )
      }
      fields.push(
      {
        key: 'isExit',
        label: '在场状态',
        type: 'select',
        options: (item) => {
          return item.dictionarys.isExit
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '姓名/身份证号/手机号'
      },
      {
        key: 'businessUid',
        label: '当前工种',
        type: 'select',
        options: (params) => {
          return params.dictionarys.business
        }
      },
      {
        key: 'ageUid',
        label: '年龄段',
        type: 'select',
        options: (params) => {
          return params.dictionarys.ageGroup
        },
        checkByValue: true
      }
      )
      return fields
    },
    rowData: (params) => {
      return params.state.builder.laborPersonList.result
    },
    rowTotal: (params) => {
      return params.state.builder.laborPersonList.totalSize
    },
    columns: (params) => {
      const columns = [{
        prop: 'name',
        label: '姓名',
        width: '100px',
        overflow: false,
        tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' }
      }]
      if (params.orgType !== 'laborCom') {
        columns.push({
          prop: 'companyName',
          label: '所属劳务公司',
          width: '260px',
          overflow: false,
          tooltip: { tipKey: 'companyFormerName', tipLabel: '曾用名：' }
        })
      }
      columns.push(
      { prop: 'business', label: '当前工种', width: '200px' },
      { prop: 'phoneNumber', label: '手机号码', width: '' },
      {
        prop: 'noteInfo',
        label: '在场状态',
        width: '80px',
        tag: (params) => {
          return params.dictionarys.isExit
        }
      },
      { prop: 'walkinDate', label: '进场时间', width: '' },
      { prop: 'walkoffDate', label: '退场时间', width: '' }
      )
      const showCommitment =
        !(params.state.builder && params.state.builder.showExitCommitmentCol === false)
      if (showCommitment) {
        columns.push({
          prop: 'isPic',
          label: '退场承诺书',
          width: '160px',
          signedDoc: {
            reportCode: 'laborPersonOut',
            previewLabel: '预览承诺书',
            imageLabel: '承诺书图片',
            lockedLabel: '暂未退场',
            lockWhen: 'notExit',
            saveFun: 'builder/uploadLaboroutpic',
            refreshFun: 'builder/getLaborPersonList',
            laborUidKey: 'uid',
            electronicSign: true,
            multi: false,
            limit: 6
          }
        })
      }
      columns.push({
        label: '操作',
        buttons: setTableButtons(['查看', '编辑', '删除', '退场', '二维码']),
        width: '380px'
      })
      return columns
    },
    hasPagination: true,
    formParams: (params) => {
      const laborCom = isLaborCompanyOrg(params.orgType)
      var formParams = {
        uid: '',
        personUid: '',
        personName: '',
        projectUid: laborCom
          ? getLaborParentBidUid(params) || params.orgValue
          : params.orgValue,
        vProjectName: laborCom
          ? getLaborParentBidName(params) || params.orgName
          : params.orgName,
        laborTeamUid: laborCom ? params.orgValue : '',
        laborTeamName: laborCom ? getLaborCompanyName(params) : '',
        teamUid: '',
        teamUids: [],
        teamName: '',
        isForeman: '0',
        walkinDate: daysFormat(new Date()),
        business: '',
        cardUid: '',
        electronicSignature: '',
        liveType: '场内住宿',
        walkoffDate: '',
        walkoffReason: '',
        isPaySure: true,
        unpaidPay: '',
        replacePay: '',
        cumulativeShouldPay: '',
        cumulativeActualPay: '',
        cumulativeOwePay: '',
        payRate: '',
        clockConfirmText: '',
        clockConfirmed: false,
        clockConfirmReady: false,
        salaryConfirmText: '',
        salaryConfirmed: false,
        skipSalaryExitFlow: false,
        skipExitCommitStep: false,
        wageDeadline: '已全部发放',
        slipCount: 0,
        picUid: '',
        fileLists: {
          electronicSignature: [],
          picUid: []
        }
      }
      return formParams
    },
    formRules: (params) => {
      const skipSalaryExit = (p) =>
        !!(p.formValues && p.formValues.skipSalaryExitFlow)
      var formRules = {
        personUid: [
          {
            required: params.pageStatus === 'add',
            message: '请搜索选择要进场的劳务人员',
            trigger: 'change'
          }
        ],
        laborTeamUid: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择要进场的劳务公司名称',
            trigger: 'blur'
          }
        ],
        walkinDate: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择进场时间',
            trigger: 'blur'
          }
        ],
        walkoffDate: [
          {
            required:
              params.pageStatus === 'edit' || params.pageStatus === 'exit',
            message: '请选择退场时间',
            trigger: 'blur'
          }
        ],
        walkoffReason: [
          {
            required:
              params.pageStatus === 'edit' || params.pageStatus === 'exit',
            message: '请选择退场原因',
            trigger: 'blur'
          }
        ],
        unpaidPay: [
          {
            required: params.pageStatus === 'edit',
            message: '请输入未结算薪酬',
            trigger: 'blur'
          }
        ],
        clockConfirmText: [
          {
            validator: (p) => {
              return (rule, value, callback) => {
                if (skipSalaryExit(p)) {
                  callback()
                  return
                }
                if (
                  p.pageStatus === 'exit' &&
                  !(p.formValues && p.formValues.clockConfirmed)
                ) {
                  callback(new Error('请先确认退场日期前的全部考勤'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'change'
          }
        ],
        salaryConfirmText: [
          {
            validator: (p) => {
              return (rule, value, callback) => {
                if (p.pageStatus !== 'exit' || skipSalaryExit(p)) {
                  callback()
                  return
                }
                if (!(p.formValues && p.formValues.clockConfirmed)) {
                  callback()
                  return
                }
                if (!(p.formValues && p.formValues.salaryConfirmed)) {
                  callback(new Error('请先确认对应月份的全部工资条'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'change'
          }
        ]
      }
      return formRules
    },
    formData: (params) => {
      const form =
        (params.state.formValues && params.state.formValues.laborPerson) || {}
      const skipSalaryExit = !!(
        (params.pageStatus === 'exit' || params.pageStatus === 'batch') &&
        form.skipSalaryExitFlow
      )
      var formData = {
        card:
          params.pageStatus === 'edit' || params.pageStatus === 'check'
            ? '劳务人员信息'
            : params.pageStatus === 'batch'
            ? '劳务人员批量退场'
            : null,
        titles:
          params.pageStatus === 'add'
            ? ['人员信息核查', '进场信息登记', '完成']
            : params.pageStatus === 'exit'
            ? skipSalaryExit
              ? ['人员信息核查', '退场信息确认']
              : ['人员信息核查', '退场信息确认', '完成']
            : null,
        finishStep: params.pageStatus === 'add' ? 2 : null,
        finishStatus: params.pageStatus === 'add' ? '备案成功' : null,
        finishtip:
          params.pageStatus === 'add' ? '备案完成并生成劳务人员二维码' : null,
        tips:
          params.pageStatus === 'add'
            ? [
                {
                  step: 0,
                  text: [
                    '1、当前工种默认为个人主业工种，可在主业工种和其他可从业工种中选择；如要选的工种不在档案中，请点击右侧添加新工种。进场时可不填，后续可在进场信息中补录。',
                    '2、银行卡和电子签名进场时可不填，后续可在进场信息中补录；薪酬结算、合同报备、退场等业务用到时需先补录。'
                  ]
                }
              ]
            : params.pageStatus === 'exit'
            ? skipSalaryExit
              ? [
                  {
                    step: 0,
                    text: [
                      '1、劳务人员办理退场手续，需要先确认退场人员信息，以免退场错误；',
                      '2、退场须由劳务公司负责人或标段管理员在Web端办理，个人小程序不再申请退场；',
                      '3、确认人员无误后进入退场信息确认，填写退场日期和退场原因即可提交。'
                    ]
                  },
                  {
                    step: 1,
                    text: [
                      '1、退场日期默认当天，退场原因已预填，均可按实际情况修改；',
                      '2、当前劳务公司未开通薪酬统计模块，无需确认考勤与工资条，也无需生成退场承诺书；',
                      '3、提交后直接完成退场并返回列表。'
                    ]
                  }
                ]
              : [
                  {
                    step: 0,
                    text: [
                      '1、劳务人员办理退场手续，需要先确认退场人员信息，以免退场错误；',
                      '2、退场须由劳务公司负责人或标段管理员在Web端办理，个人小程序不再申请退场；',
                      '3、确认人员无误后进入退场信息确认，按实际退场日期核对考勤和工资条。'
                    ]
                  },
                  {
                    step: 1,
                    text: [
                      '1、退场日期默认当天，退场原因已预填，均可按实际情况修改；',
                      '2、须先确认进场日至退场日之间所有月份考勤（含当月），全部确认后才查询并确认对应工资条；',
                      '3、无欠薪时欠薪发放期限默认为“已全部发放”；有欠薪须选择最迟结清日期，该信息写入退场承诺书第一款第2条。'
                    ]
                  }
                ]
            : null,
        bottomButtons:
          params.pageStatus === 'add'
            ? getStepFormBottomButtons(0)
            : params.pageStatus === 'exit'
            ? getStepFormBottomButtons(2)
            : params.pageStatus !== 'check'
            ? setFormButtons(['取消', '提交'])
            : null,
        fields: [
          {
            key: params.pageStatus === 'add' ? 'personUid' : null,
            label: '劳务人员姓名',
            type: params.pageStatus === 'add' ? 'select' : null,
            step: 0,
            placeholder:
              '请输入姓名或身份证号在人员库中搜索，未搜索到请先去添加人员',
            filterable: true,
            remote: true,
            optionImg: true,
            optionPerson: true,
            checkByValue: true,
            echoLabelKey: 'personName',
            options: (p) => {
              return withSelectedOption(
                p.state.person.personNames,
                p.formValues && p.formValues.personUid,
                p.formValues && p.formValues.personName
              )
            }
          },
          {
            type: params.pageStatus === 'add' ? 'tag' : null,
            step: 0,
            tagType: (params) => {
              return params.formValues && params.formValues.personUid
                ? ''
                : 'danger'
            },
            tagIcon: (params) => {
              return params.formValues && params.formValues.personUid
                ? 'el-icon-success'
                : 'el-icon-warning'
            },
            tag: (params) => {
              return params.formValues && params.formValues.personUid
                ? '你已选择要进场的劳务人员，进场前可点击查看或完善其个人档案，身份信息不可改，其他缺项可提前补全。'
                : '如果未搜索到要进场的劳务人员，请先去添加人员后再选择。'
            },
            // 放右侧 check 列，避免与 tip 挤在中间同一行
            check: (params) => {
              return params.formValues && params.formValues.personUid
                ? '查看或完善个人档案'
                : '去添加人员'
            }
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'batch'
                ? 'personName'
                : null,
            label: '劳务人员姓名',
            step: 0,
            type: 'input',
            disabled: true,
            check: '查看个人档案'
          },
          {
            key: params.pageStatus === 'batch' ? 'selectionPerson' : null,
            label: '劳务人员姓名',
            step: 0,
            type: 'input',
            inputType: 'textarea',
            autosize: true,
            disabled: true
          },
          {
            key: 'vProjectName',
            label: '所属项目标段',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: true
          },
          {
            key: (params) => {
              if (isLaborCompanyOrg(params.orgType)) return null
              return params.pageStatus === 'add' ? 'laborTeamUid' : null
            },
            label: '所属劳务公司',
            type: (params) => {
              if (isLaborCompanyOrg(params.orgType)) return null
              return params.pageStatus === 'add' ? 'select' : null
            },
            step: 1,
            placeholder: '请搜索选择',
            filterable: true,
            options: (params) => {
              return params.state.bidSection.unExitLaborCompanys
            },
            checkByValue: true
          },
          {
            key: (fieldParams) => {
              if (isLaborCompanyOrg(fieldParams.orgType)) return 'laborTeamName'
              return fieldParams.pageStatus !== 'add' ? 'laborTeamName' : null
            },
            label: '所属劳务公司',
            step: params.pageStatus === 'add' ? 1 : 0,
            type: 'input',
            disabled: true
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'teamUids'
                : null,
            label: '所属作业班组',
            type: 'select',
            multiple: true,
            step: params.pageStatus === 'add' ? 1 : 0,
            placeholder: '可不选，可同时关联多个班组',
            options: (params) => {
              return withSelectedOptions(
                params.state.contractor.teamNames,
                params.formValues && params.formValues.teamUids,
                params.formValues && params.formValues.teamName
              )
            },
            checkByValue: true,
            echoLabelKey: 'teamName'
          },
          {
            key:
              params.pageStatus === 'check' || params.pageStatus === 'exit'
                ? 'teamName'
                : null,
            label: '所属作业班组',
            step: 0,
            type: 'input'
          },
          {
            key: params.pageStatus !== 'batch' ? 'walkinDate' : null,
            label: '进场日期',
            type: 'time',
            step:
              params.pageStatus === 'add' || params.pageStatus === 'exit'
                ? 1
                : 0
          },
          {
            key:
              params.pageStatus !== 'exit' && params.pageStatus !== 'batch'
                ? 'business'
                : null,
            label: '当前工种',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            filterable: true,
            placeholder: '可不填，后期补录',
            options: (params) => {
              return params.state.person.perBusiness || []
            },
            check: (params) => {
              if (
                params.pageStatus !== 'add' &&
                params.pageStatus !== 'edit'
              ) {
                return null
              }
              const registered = params.state.person.perBusiness || []
              return registered.length ? '添加新工种' : '完善档案工种'
            }
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'cardUid'
                : null,
            label: '银行卡',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: (params) => {
              return withSelectedOption(
                params.state.person.perBackCard,
                params.formValues && params.formValues.cardUid,
                params.formValues &&
                  (params.formValues.backCard || params.formValues.cardNum)
              )
            },
            checkByValue: true,
            echoLabelKey: 'backCard',
            check: '添加银行卡'
          },
          {
            key: params.pageStatus === 'check' ? 'backCard' : null,
            label: '银行卡',
            type: 'input'
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'electronicSignature'
                : null,
            label: '电子签名',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: (params) => {
              return withSelectedOption(
                params.state.person.perSignature,
                params.formValues && params.formValues.electronicSignature,
                params.formValues &&
                  (params.formValues.electorName ||
                    params.formValues.signatureName)
              )
            },
            optionImg: true,
            optionImgType: 'signature',
            checkByValue: true,
            echoLabelKey: 'electorName',
            check: '添加新签名'
          },
          {
            key: params.pageStatus === 'check' ? 'electronicSignature' : null,
            label: '电子签名',
            type: 'upload',
            fileType: 'signature',
            url: '/static/files/signature',
            listType: 'text',
            showFilelist: false
          },
          {
            key:
              params.pageStatus !== 'exit' && params.pageStatus !== 'batch'
                ? 'liveType'
                : null,
            label: '工人住宿类型',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: (params) => {
              return params.dictionarys.liveType
            }
          },
          {
            type: params.pageStatus === 'exit' ? 'tag' : null,
            step: 0,
            tagIcon: 'el-icon-success',
            tag: '劳务人员办理退场手续前，请先查看人员档案确认选择无误。'
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'edit'
                ? 'walkoffDate'
                : null,
            label: '退场日期',
            type: 'time',
            step: params.pageStatus === 'exit' ? 1 : 0
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'edit'
                ? 'walkoffReason'
                : null,
            label: '退场原因',
            type: 'select',
            step: params.pageStatus === 'exit' ? 1 : 0,
            options: (params) => {
              return params.dictionarys.walkoffCause
            }
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'clockConfirmText'
                : null,
            label: '考勤确认',
            type: 'input',
            step: 1,
            disabled: true,
            inputButton: (p) => {
              if (!p.formValues || !p.formValues.clockConfirmReady) {
                return ''
              }
              return p.formValues.clockConfirmed ? '已确认' : '未确认'
            },
            check: (p) => {
              if (!p.formValues || !p.formValues.clockConfirmReady) {
                return null
              }
              return p.formValues.clockConfirmed ? '查看明细' : '去确认'
            }
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'salaryConfirmText'
                : null,
            label: '薪酬确认',
            type: 'input',
            step: 1,
            disabled: true,
            placeholder: (p) => {
              if (!p.formValues || !p.formValues.clockConfirmed) {
                return '请先确认考勤'
              }
              return ''
            },
            inputButton: (p) => {
              if (!p.formValues || !p.formValues.clockConfirmed) {
                return ''
              }
              return p.formValues.salaryConfirmed ? '已确认' : '未确认'
            },
            check: (p) => {
              if (!p.formValues || !p.formValues.clockConfirmed) {
                return null
              }
              return p.formValues.salaryConfirmed ? '查看明细' : '去确认'
            }
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'wageDeadline'
                : null,
            label: '欠薪发放期限',
            type: (p) => {
              const owe = Number(
                (p.formValues && p.formValues.cumulativeOwePay) || 0
              )
              return owe > 0 ? 'time' : 'input'
            },
            step: 1,
            disabled: (p) => {
              const owe = Number(
                (p.formValues && p.formValues.cumulativeOwePay) || 0
              )
              return !(owe > 0)
            },
            placeholder: '请选择最迟结清日期'
          },
          {
            key:
              params.pageStatus === 'check' ||
              (params.pageStatus === 'exit' && !skipSalaryExit)
                ? 'picUid'
                : null,
            label: '退场承诺书',
            type: 'signedReport',
            reportCode: 'laborPersonOut',
            saveFun: 'builder/uploadLaboroutpic',
            laborUidKey: 'uid',
            previewLabel: '预览承诺书',
            imageLabel: '承诺书图片',
            electronicSign: true,
            lockWhen: 'notExit',
            limit: 6,
            step: params.pageStatus === 'exit' ? 2 : 0
          }
        ]
      }
      return formData
    },
    personUser: personUser,
    bankCard: person.person.bankCard,
    signature: person.person.signature,
    personBusiness: {
      name: 'personBusiness',
      title: '完善档案工种',
      addFun: 'person/editPerson',
      getParentFun: 'person/getCurrentBusiness',
      formParams: {
        uid: (params) => {
          const form = params.state.formValues.laborPerson
          return form && form.personUid ? form.personUid : ''
        },
        mainBusiness: '',
        otherBusiness: []
      },
      formRules: {
        mainBusiness: [
          {
            required: true,
            message: '请选择主业工种',
            trigger: 'change'
          }
        ],
        otherBusiness: [
          {
            validator: (params) => {
              return params.validate.validateOtherBusiness
            },
            type: 'array',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'mainBusiness',
          label: '主业工种',
          type: 'select',
          placeholder: '请搜索或输入',
          filterable: true,
          create: true,
          options: (params) => {
            return params.dictionarys.business
          },
          span: 18
        },
        {
          key: 'otherBusiness',
          label: '其他可从业工种',
          type: 'select',
          placeholder: '请搜索或输入，最多五项',
          multiple: true,
          filterable: true,
          create: true,
          options: (params) => {
            return params.dictionarys.business
          },
          span: 18
        }
      ]
    },
    addPersonBusiness: {
      name: 'addPersonBusiness',
      title: '添加新工种',
      addFun: 'person/addPersonOtherBusiness',
      getParentFun: 'person/getCurrentBusiness',
      formParams: {
        uid: (params) => {
          const form = params.state.formValues.laborPerson
          return form && form.personUid ? form.personUid : ''
        },
        personUid: (params) => {
          const form = params.state.formValues.laborPerson
          return form && form.personUid ? form.personUid : ''
        },
        business: []
      },
      formRules: {
        business: [
          {
            required: true,
            message: '请选择要添加的工种',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'business',
          label: '工种',
          type: 'select',
          placeholder: '请从工种字典中搜索选择，将写入其他可从业工种',
          multiple: true,
          filterable: true,
          options: (params) => {
            const all = params.dictionarys.business || []
            const registered = (params.state.person.perBusiness || []).map(
              (item) => item.label || item.value
            )
            return all.filter((item) => {
              return registered.indexOf(item.label) === -1
            })
          },
          span: 18
        }
      ]
    }
  },
  managePerson: {
    name: 'managePerson',
    theme: '管理人员',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'dialogForm',
      'perForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    selectColumn: true,
    headButtons: setCheckButtons(['进场', '批量退场']),
    getListFun: 'builder/getManagePersonList',
    deleteFun: 'builder/deleteManagePerson',
    deleteConfirm: (params) => {
      if (params.userName === 'dpnadmin') {
        return '将删除该管理人员在所在项目的全部业务数据，且不可恢复。是否继续？'
      }
      return '此操作将永久删除该条数据, 是否继续?'
    },
    getDetailFun: 'builder/getManagePersonInfo',
    addFun: 'builder/addManagePerson',
    editFun: 'builder/editManagePerson',
    exitFun: 'builder/exitManagePerson',
    exitArray: true,
    detailPage: [
      {
        buttonNames: ['进场', '批量退场'],
        type: 'stepForm',
        name: 'managePerson',
        step: 'managePersonInfo',
        theme: 'builder',
        label: () => {
          return (params) => {
            if (params.code === 'add') {
              return '管理人员进场登记'
            } else if (params.code === 'batch') {
              return '管理人员批量退场'
            }
          }
        }
      },
      {
        buttonNames: ['编辑', '查看'],
        type: 'stepForm',
        name: 'managePerson',
        checkType: 'checkByUid',
        checkFun: 'builder/getManagePersonInfo',
        step: 'managePersonInfo',
        theme: 'builder',
        label: () => {
          return (params) => {
            if (params.code === 'edit') {
              return '编辑管理人员信息'
            } else if (params.code === 'check') {
              return '查看管理人员信息'
            } else if (params.code === 'exit') {
              return '管理人员退场登记'
            }
          }
        }
      },
      {
        buttonName: '退场',
        type: 'stepForm',
        name: 'managePerson',
        checkType: 'useRowData',
        step: 'managePersonInfo',
        theme: 'builder',
        label: '管理人员退场登记'
      },
      {
        buttonName: '查看个人档案',
        type: 'cardForm',
        name: 'person',
        label: '查看个人档案',
        theme: 'builder',
        step: 'personInfo',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.formValues ? params.formValues.personUid : ''
        },
        checkFun: 'person/getPersonInfo',
        pageStatus: 'complete'
      },
      {
        buttonName: '新增个人档案',
        type: 'dialogForm',
        name: 'personUser',
        pageStatus: 'add'
      },
      {
        buttonName: '添加新签名',
        type: 'dialogForm',
        name: 'signature',
        pageStatus: 'add',
        uidKey: 'personUid'
      }
    ],
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      vProjectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      isExit: '',
      employMethod: '',
      query: ''
    },
    selectData: [
      {
        key: 'vProjectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },

      {
        key: 'isExit',
        label: '在场状态',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isExit
        }
      },
      {
        key: 'employMethod',
        label: '聘用方式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.employMethod
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '姓名/手机号/管理单位名称'
      }
    ],
    rowData: (params) => {
      return params.state.builder.managePersonList.result
    },
    rowTotal: (params) => {
      return params.state.builder.managePersonList.totalSize
    },
    columns: (params) => {
      const columns = [{
        prop: 'personName',
        label: '姓名',
        width: '100px',
        overflow: false,
        tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' }
      }]
      if (params.orgType !== 'simPro' && params.orgType !== 'laborCom') {
        columns.push({
          prop: 'projectCode',
          label: '项目标段',
          width: '200px'
        })
      }
      columns.push(
      { prop: 'companyName', label: '所属管理单位', width: '260px', overflow: false, tooltip: { tipKey: 'companyFormerName', tipLabel: '曾用名：' } },
      { prop: 'jobTitle', label: '岗位职务', width: '' },
      {
        prop: 'employmentMethod',
        label: '聘用方式',
        width: '100px',
        tag: [
          {
            type: 'danger',
            label: '临聘'
          }
        ]
      },
      { prop: 'phoneNumber', label: '手机号码', width: '' },
      {
        prop: 'noteInfo',
        label: '在场状态',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.isExit
        }
      },
      { prop: 'walkinDate', label: '进场时间', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['查看', '编辑', '删除', '退场', '二维码']),
        width: '380px'
      }
      )
      return columns
    },
    hasPagination: true,
    formParams: {
      uid: '',
      personUid: '',
      projectUid: (params) => {
        return params.orgValue
      },
      vProjectName: (params) => {
        return params.orgName
      },
      companyUid: '',
      companyName: '',
      entryDate: daysFormat(new Date()),
      employMethod: '全职',
      departmentUid: '',
      department: '',
      jobTitle: '',
      jobTitleCode: '',
      jobTitleName: '',
      elecAutographUid: '',
      exitDate: '',
      exitReason: '',
      fileLists: {
        elecAutographUid: []
      }
    },
    formRules: (params) => {
      var formRules = {
        personUid: [
          {
            required: params.pageStatus === 'add',
            message: '请选择进场的管理人员',
            trigger: 'blur'
          }
        ],
        entryDate: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择进场时间',
            trigger: 'blur'
          }
        ],
        employMethod: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择聘用方式',
            trigger: 'blur'
          }
        ],
        departmentUid: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择科室部门',
            trigger: 'blur'
          }
        ],
        jobTitle: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择岗位职务',
            trigger: 'blur'
          }
        ],
        exitDate: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场时间',
            trigger: 'blur'
          }
        ],
        exitReason: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场原因',
            trigger: 'blur'
          }
        ]
      }
      return formRules
    },
    formData: (params) => {
      var formData = {
        card: params.pageStatus !== 'add' ? '管理人员信息' : null,
        titles:
          params.pageStatus === 'add'
            ? ['人员信息核查', '进场信息登记', '完成']
            : null,
        finishStep: params.pageStatus === 'add' ? 2 : null,
        finishStatus: params.pageStatus === 'add' ? '备案成功' : null,
        finishtip:
          params.pageStatus === 'add' ? '备案完成并生成管理人员二维码' : null,
        tips:
          params.pageStatus === 'add'
            ? [
                {
                  step: 0,
                  text: [
                    '1、参建人员进场前先确认人员档案信息完善情况符合要进场的项目标段的管理要求；',
                    '2、项目领导班子成员进场办理科室部门应选择的部门为“领导班子”；',
                    '3、进场时要选择的科室部门或岗位职务没有在选项中可以联系管理员添加。',
                    '4、电子签名进场时可不填，后续可在进场信息中补录。'
                  ]
                }
              ]
            : null,
        bottomButtons:
          params.pageStatus === 'add'
            ? getStepFormBottomButtons(0)
            : setFormButtons(['取消', '提交']),
        fields: [
          {
            key: params.pageStatus === 'add' ? 'personUid' : null,
            label: '管理人员姓名',
            type: 'select',
            step: 0,
            placeholder:
              '请输入姓名或身份证号在人员库中搜索，未搜索到请先去添加人员',
            filterable: true,
            clearable: true,
            remote: true,
            optionImg: true,
            optionPerson: true,
            checkByValue: true,
            echoLabelKey: 'personName',
            options: (p) => {
              return withSelectedOption(
                p.state.person.personNames,
                p.formValues && p.formValues.personUid,
                p.formValues && p.formValues.personName
              )
            }
          },
          {
            type: params.pageStatus === 'add' ? 'tag' : null,
            step: 0,
            tagType: (params) => {
              return params.formValues && params.formValues.personUid
                ? ''
                : 'danger'
            },
            tagIcon: (params) => {
              return params.formValues && params.formValues.personUid
                ? 'el-icon-success'
                : 'el-icon-warning'
            },
            tag: (params) => {
              return params.formValues && params.formValues.personUid
                ? '你已选择要进场的管理人员，进场前可点击查看其个人档案详情，确认是否符合信息采集要求。'
                : '如果未搜索到要进场的管理人员，则该人员未注册系统账户或未完成个人档案实名认证。'
            },
            check: (params) => {
              return params.formValues && params.formValues.personUid
                ? '查看个人档案'
                : '新增个人档案'
            }
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'batch'
                ? 'personName'
                : null,
            label: '管理人员姓名',
            type: 'input',
            disabled: true,
            check: '查看个人档案'
          },
          {
            key: params.pageStatus === 'batch' ? 'selectionPerson' : null,
            label: '管理人员姓名',
            step: 0,
            type: 'input',
            inputType: 'textarea',
            autosize: true,
            disabled: true
          },
          {
            key: 'vProjectName',
            label: '所属项目标段',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: true
          },
          {
            key: 'companyName',
            label: '所属管理单位',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: true
          },
          {
            key: params.pageStatus !== 'batch' ? 'entryDate' : null,
            label: '进场日期',
            type: 'time',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: params.pageStatus === 'exit'
          },
          {
            key:
              params.pageStatus !== 'batch' && params.pageStatus !== 'exit'
                ? 'employMethod'
                : null,
            label: '聘用方式',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: params.dictionarys.employMethod
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'departmentUid'
                : null,
            label: '职能部门',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options:
              params.orgFields.department && params.orgFields.department.length
                ? params.orgFields.department[0].children
                : [],
            checkByValue: true
          },
          {
            key: params.pageStatus === 'check' ? 'departmentName' : null,
            label: '职能部门',
            type: 'input'
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'jobTitle'
                : null,
            label: '岗位职务',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options:
              params.orgFields.jobTitle && params.orgFields.jobTitle.length
                ? params.orgFields.jobTitle[0].children
                : [],
            checkByValue: true
          },
          {
            key: params.pageStatus === 'check' ? 'jobTitleName' : null,
            label: '职能部门',
            type: 'input'
          },
          {
            key:
              params.pageStatus === 'add' || params.pageStatus === 'edit'
                ? 'elecAutographUid'
                : null,
            label: '电子签名',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: params.state.person.perSignature,
            optionImg: true,
            optionImgType: 'signature',
            checkByValue: true,
            check: '添加新签名'
          },
          {
            key: params.pageStatus === 'check' ? 'elecAutographUid' : null,
            label: '电子签名',
            type: 'upload',
            fileType: 'signature',
            url: '/static/files/signature',
            listType: 'text',
            showFilelist: false
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'edit'
                ? 'exitDate'
                : null,
            label: '退场日期',
            type: 'time'
          },
          {
            key:
              params.pageStatus !== 'add' && params.pageStatus !== 'edit'
                ? 'exitReason'
                : null,
            label: '退场原因',
            type: 'select',
            options: params.dictionarys.walkoffCause
          }
        ]
      }
      return formData
    },
    personUser: personUser,
    signature: person.person.signature
  },
  person: person.person,
  esign
}

export default builder
